<template>
    <!-- 线上线下一站式解决方案 -->
    <section class="home-online-offline">
        <header class="online-offline-header">
            <div class="header-title">
                <p>线上线下一站式解决方案</p>
                <p>On-line and offline one-stop solution</p>
            </div>
            <div class="header-icon">
                <el-image style="width: 71px; height: 71px" :src="require(`${'@/assets/webImg/home/oo_right.png'}`)" fit="cover"></el-image>
            </div>
        </header>
         <div class="online-offline-swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <section class="swiper-slide-policeholder">
                     
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="swiper-slide-content">
                        <div class="slide-img">
                            <img src="@/assets/webImg/home/oo_1.png" alt="">
                        </div>
                        <p class="slide-f">人事管理平台</p>
                        <p class="slide-l">平台介绍文案信息 平台介绍文案信息 平台介绍文案信息</p>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="swiper-slide-content">
                        <div class="slide-img">
                            <img src="@/assets/webImg/home/oo_2.png" alt="">
                        </div>
                        <p class="slide-f">财务管理平台</p>
                        <p class="slide-l">平台介绍文案信息 平台介绍文案信息 平台介绍文案信息</p>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="swiper-slide-content">
                        <div class="slide-img">
                            <img src="@/assets/webImg/home/oo_3.png" alt="">
                        </div>
                        <p class="slide-f">税务管理平台</p>
                        <p class="slide-l">平台介绍文案信息 平台介绍文案信息 平台介绍文案信息</p>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="swiper-slide-content">
                        <div class="slide-img">
                            <img src="@/assets/webImg/home/oo_4.png" alt="">
                        </div>
                        <p class="slide-f">财务外包代理记账</p>
                        <p class="slide-l">平台介绍文案信息 平台介绍文案信息 平台介绍文案信息</p>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="swiper-slide-content">
                        <div class="slide-img">
                            <img src="@/assets/webImg/home/oo_5.png" alt="">
                        </div>
                        <p class="slide-f">财税代扣代缴代申报</p>
                        <p class="slide-l">平台介绍文案信息 平台介绍文案信息 平台介绍文案信息</p>
                    </section>
                </div>
                <div class="swiper-slide">
                    <section class="swiper-slide-content">
                        <div class="slide-img">
                            <img src="@/assets/webImg/home/oo_5.png" alt="">
                        </div>
                        <p class="slide-f">报销薪资代核代发</p>
                        <p class="slide-l">平台介绍文案信息 平台介绍文案信息 平台介绍文案信息</p>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

    mounted() {
        var swiper2 = new Swiper('.online-offline-swiper-container', {
            slidesPerView: 5,
            // loop: true,
            // centeredSlides: true,
            spaceBetween : 18,
            grabCursor: true,       // 小手
        });

    },

    methods: {
    }
}
</script>

<style lang="scss">
.home-online-offline {
    margin-top: 76px;
    width: 100%;
    position: relative;
    &::before {
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 546px;
        background: #F6F8FA;
    }
    .online-offline-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 160px;
        margin-bottom: 68px;
        .header-title {
            position: relative;
            z-index: 999;
            p:first-child {
                padding-top: 33px;
                height: 56px;
                line-height: 56px;
                font-size: 40px;
                font-weight: 500;
                color: #363636;
            }
            p:last-child {
                height: 46px;
                font-size: 33px;
                font-weight: 500;
                color: #B5B5B5;
                line-height: 46px;
            }
        }
    }
    .online-offline-swiper-container {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        
        .swiper-slide-content {
            width: 330px;
            height: 408px;
            background: #FFFFFF;
            box-shadow: 0px 6px 11px 0px rgba(202, 195, 195, 0.23);
            border-radius: 30px;
            box-sizing: border-box;
            padding-top: 60px;
            margin-bottom: 20px;
            text-align: center;
            .slide-img {
     
                height: 80px;
                width: 100%;
                text-align: center;
                img {
                    display: inline-block;
                    height: 100%;
                }
            }

            .slide-f {
                margin-top: 60px;
                font-size: 31px;
                font-weight: 500;
                color: #363636;
                line-height: 43px;
            }
            .slide-l {
                margin: 0 auto;
                margin-top: 14px;
                width: 162px;
                font-size: 20px;
                color: #333333;
                line-height: 28px;
            }
        }
        .swiper-slide-policeholder {
            width: 120px !important;

        }
        .swiper-slide:first-child {
            width: 120px !important;
        }

        // .swiper-slide:first-child {
        //     width: 490px;
        //     .swiper-slide-content {
        //         width: 100%;
        //         border-left: 160px solid red;
        //     }
        // }

    }
   
}

</style>
